module.exports = __webpack_public_path__ + "static/media/text-to-text.2fc3f34a.png";